<script setup>
import { useHeading } from '~/composables/heading.js'

defineOptions({
  name: 'BaseTitle',
})

const props = defineProps({
  title: String,
  align: String,
  justify: String,
  dense: Boolean,
  space: [Number, String],
  tag: {
    type: String,
    default: 'h3',
  },
  size: {
    type: String,
    default: 'text-h6',
  },
  mobileSize: {
    type: String,
    default: 'text-subtitle-1',
  },
  weight: {
    type: String,
    default: 'bold',
  },
  mobileBreakpoint: {
    type: [Number, String],
    default: 768,
  },
})

const { align, justify } = useHeading(toRef(props, 'align'))
</script>

<template lang="pug">
  base-heading(v-bind="props")
    slot
</template>
